module.exports = __webpack_public_path__ + "img/icon108.edeab0fb.png";